var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { key: "profile-setup", staticClass: "t-onboard__body" }, [
    _c("div", { staticClass: "t-onboard__main" }, [
      _c(
        "div",
        { staticClass: "t-onboard__content" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.loaded
            ? [
                _c("div", { staticClass: "t-onboard__title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("onboard.register.profile.title")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "t-onboard__description" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("onboard.register.profile.description")) +
                      "\n        "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "t-onboard__form" },
                  [
                    _c(
                      "div",
                      { staticClass: "t-onboard__fields" },
                      [
                        _c(
                          "div",
                          { staticClass: "t-onboard__field" },
                          [
                            _c("t-input", {
                              attrs: {
                                fluid: "",
                                label: _vm.$t("onboard.register.profile.name"),
                                placeholder: _vm.$t(
                                  "onboard.register.profile.placeholder"
                                ),
                                invalid: _vm.invalid,
                                "max-length": 50,
                                focus: true,
                                required: true,
                              },
                              on: {
                                keyup: [
                                  function ($event) {
                                    _vm.invalid = false
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    )
                                      return null
                                    return _vm.createUserProfile()
                                  },
                                ],
                              },
                              model: {
                                value: _vm.name,
                                callback: function ($$v) {
                                  _vm.name = $$v
                                },
                                expression: "name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.questions, function (question) {
                          return _c(
                            "div",
                            {
                              key: question.profile_id,
                              staticClass: "t-onboard__field",
                            },
                            [
                              question.multi_select
                                ? [
                                    _c("tube-label", {
                                      staticClass: "t-mar--b-mi",
                                      attrs: {
                                        required: true,
                                        label: _vm.profileQuestion(
                                          question.profile_id
                                        ),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("multiselect", {
                                      class: {
                                        "multiselect--invalid":
                                          _vm.errors[question.profile_id],
                                      },
                                      attrs: {
                                        id: question.profile_id,
                                        value:
                                          _vm.userProfile[
                                            question.profile_id
                                          ] || [],
                                        options: _vm.availableOptions(
                                          question.profile_id
                                        ),
                                        placeholder: "select",
                                        "hide-selected": true,
                                        "track-by": "value",
                                        label: "name",
                                        searchable: false,
                                        multiple: true,
                                        taggable: true,
                                        "show-labels": false,
                                      },
                                      on: {
                                        input: _vm.updateProfileMultiSelect,
                                      },
                                    }),
                                  ]
                                : _c("t-select", {
                                    attrs: {
                                      value:
                                        _vm.userProfile[question.profile_id],
                                      name: question.profile_id,
                                      "is-invalid":
                                        _vm.errors[question.profile_id],
                                      placeholder: "select",
                                      label: _vm.profileQuestion(
                                        question.profile_id
                                      ),
                                      required: true,
                                      options: _vm.availableOptions(
                                        question.profile_id
                                      ),
                                    },
                                    on: { update: _vm.updateProfile },
                                  }),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "t-button",
                      {
                        staticClass: "t-mar--t-sm",
                        attrs: {
                          fluid: "",
                          variant: "primary",
                          size: "large",
                          loading: _vm.loader,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.createUserProfile()
                          },
                        },
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("onboard.register.profile.cta"))
                          ),
                        ]),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "t-onboard__logo" }, [
      _c("img", {
        attrs: {
          src: require("@/lib/assets/images/Trainn-CB-logo.svg"),
          height: "36px",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }